<template>
  <div class="poi">
    <!-- <img :src="img" alt="" srcset=""> -->
    <valstatusicon class="mt" :info="val1" />
    <valstatusicon class="mt" :info="val2" />
    <valstatusicon class="mt" :info="val3" />
    <div id="cards">
      <card class="fl" :info="val41" />
      <card class="fl" :info="val42" />
      <card class="fl" :info="val43" />
      <card class="fl" :info="val44" />
      <card class="fl" :info="val45" />
      <card class="fl" :info="val46" />
    </div>

    <div id="card2s">
      <card2 class="fl2" :info="val51" />
      <card2 class="fl2" :info="val52" />
    </div>
  </div>
</template>

<script>
import valstatusicon from "../valstatus/icon.vue";
import card from "../valstatus/card.vue";
import card2 from "../valstatus/card2.vue";
import img from "../img/1.png";
// import cfg from "./config.js";
export default {
  components: { valstatusicon, card, card2 },
  props: ["datainfo"],
  mounted() {
    this.val1.key = this.datainfo.data[0].formObjects[0].name
    this.val1.val = this.filterGetStatusByValue(
      this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[0].value,
        "value"
      ),
      this.datainfo.data[0].formObjects[0].statusMap
    );
    this.val1.color = this.val1.val == '运行' ? "green" : "red";
    this.val2.key = this.datainfo.data[0].formObjects[1].name
    this.val2.val = this.filterGetStatusByValue(
      this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[1].value,
        "value"
      ),
      this.datainfo.data[0].formObjects[1].statusMap
    );
    this.val2.color = this.val2.val == '正常' ? "green" : "red";
    this.val3.key = this.datainfo.data[0].formObjects[2].name
    this.val3.val = this.filterGetStatusByValue(
      this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[2].value,
        "value"
      ),
      this.datainfo.data[0].formObjects[2].statusMap
    );
    this.val3.color = this.val3.val == '充电' ? "green" : "red";

    this.val41 = {
      key: this.datainfo.data[0].formObjects[3].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[3].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[3].unit,
    };
    this.val42 = {
      key:  this.datainfo.data[0].formObjects[4].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[4].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[4].unit,
    };
    this.val43 = {
      key:  this.datainfo.data[0].formObjects[5].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[5].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[5].unit,
    };
    this.val44 = {
      key:  this.datainfo.data[0].formObjects[6].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[6].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[6].unit,
    };
    this.val45 = {
      key:  this.datainfo.data[0].formObjects[7].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[7].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[7].unit,
    };
    this.val46 = {
      key:  this.datainfo.data[0].formObjects[8].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[8].value,
        "value"
      ),
      unit: this.datainfo.data[0].formObjects[8].unit,
    };

    this.val51 = {
      key:  this.datainfo.data[0].formObjects[9].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[9].value,
        "value"
      ),
      color: "green",
      unit: this.datainfo.data[0].formObjects[9].unit,
      icon: "none",
    };
    this.val52 = {
      key:  this.datainfo.data[0].formObjects[10].name,
      val: this.filterJsonStrParse(
        this.datainfo.data[0].formObjects[10].value,
        "value"
      ),
      color: "green",
      unit: this.datainfo.data[0].formObjects[10].unit,
      icon: "none",
    };
  },
  data() {
    return {
      val1: { key: "运行状态", val: "停机", color: "red", icon: "pcs1" },
      val2: { key: "故障汇总", val: "故障", color: "red", icon: "pcs2" },
      val3: { key: "充放电状态", val: "充电", color: "green", icon: "pcs3" },

      val41: { key: "AB线电压", val: "410.5", unit: "V" },
      val42: { key: "BC线电压", val: "410.5", unit: "V" },
      val43: { key: "AC线电压", val: "410.5", unit: "V" },
      val44: { key: "A相电流", val: "410.5", unit: "A" },
      val45: { key: "B相电流", val: "410.5", unit: "A" },
      val46: { key: "C相电流", val: "410.5", unit: "A" },

      val51: {
        key: "交流侧总有功功率",
        val: "150.6",
        color: "green",
        unit: "KW",
        icon: "none",
      },
      val52: {
        key: "交流侧总无功功率",
        val: "150.6",
        color: "green",
        unit: "KVar",
        icon: "none",
      },

      img,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
  width: 100%;
  left: 0;
  top: -0.4rem;
  z-index: 0;
}
.poi {
  padding-top: 0.1rem;
  height: 2rem;
}
.mt {
  margin-top: 0.03rem;
  margin-bottom: 0.1rem;
  // overflow: hidden;
}
.fl {
  float: left;
  margin-top: 0.05rem;
  margin-right: 0.09rem;
}
.fl:nth-child(3n) {
  margin-right: 0;
}

.fl2 {
  float: left;
  margin-top: 0.1rem;
  margin-right: 0.1rem;
}
.fl2:nth-child(2n) {
  float: right;
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/data/pcs.vue